import React, { Component, useState } from "react";
import "./App.scss";
import "@progress/kendo-theme-bootstrap/dist/all.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Ambulance from "./pages/Ambulance";
import Medics from "./pages/Medics";
import Facilities from "./pages/Facilities";
import Guides from "./pages/Guides";
import Videos from "./pages/Videos";
import Kits from "./pages/Kits";
import Landing from "./pages/Landing";
import Footer from "./nav/Footer";

function App() {
  return (
    <div className="content">
      <BrowserRouter>
        <Switch>
          <Route path="/guides">
            <Guides />
          </Route>
          <Route path="/medics">
            <Medics />
          </Route>
          <Route path="/facilities">
            <Facilities />
          </Route>
          <Route path="/videos">
            <Videos />
          </Route>
          <Route path="/kits">
            <Kits />
          </Route>
          <Route path="/ambulance">
            <Ambulance />
          </Route>

          <Route path="/">
            <Landing />
          </Route>
        </Switch>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
